import Sidebar from "../sidebar/Sidebar";
import Header from "../header/Header";

const Layout = (props) => {
    return (
        <>
            <Sidebar/>
            <main>
                <Header />
                {props.children}
            </main>
        </>
    )
}

export default Layout;